import { Component, OnInit, ViewChild } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { Subscription } from 'rxjs';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { GrundbuchgeschaeftSucheStandardComponent } from './grundbuchgeschaeft-suche-standard/grundbuchgeschaeft-suche-standard.component';
import { GrundbuchgeschaeftSucheEgbtbidComponent } from './grundbuchgeschaeft-suche-egbtbid/grundbuchgeschaeft-suche-egbtbid.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-grundbuchgeschaeft-suche',
  templateUrl: './grundbuchgeschaeft-suche.component.html',
  styleUrls: ['./grundbuchgeschaeft-suche.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    GrundbuchgeschaeftSucheStandardComponent,
    GrundbuchgeschaeftSucheEgbtbidComponent,
    NgbNavOutlet,
    TranslatePipe
  ]
})
export class GrundbuchgeschaeftSucheComponent implements OnInit {
  @ViewChild('navset', { static: true })
  ngbNav: NgbNav;

  searchMode;

  private subscription: Subscription;

  constructor(private stateService: SearchStateService) {
    keysToTranslate<string>(['Grundbuchgeschäfte', 'sucheNachGrundbuchgeschäften', 'Hängig']);
  }

  ngOnInit() {
    this.searchMode = this.stateService.lastSearchMode || 'searchStandard';
  }
}
